import { EnvNames } from './environment-names.enum';
import { PinnaklEnvironmentAmplitudeConfiguration } from './environment.model';

export type EnvironmentUrlMap = Record<EnvNames, string>;
export type AmplitudeConfigurationMap = Record<EnvNames, PinnaklEnvironmentAmplitudeConfiguration | null>;

export const requestTimeoutPeriods: Record<EnvNames, number> = {
  [EnvNames.local]: 3000000,
  [EnvNames.dev]: 300000,
  [EnvNames.staging]: 300000,
  [EnvNames.prod]: 30000,
};

export const amplitudeConfigurations: AmplitudeConfigurationMap = {
  [EnvNames.local]: null,
  [EnvNames.dev]: {
    apiKey: '2c829222d05853cf2d2881912841b562',
    flushIntervalMillis: 5000,
  },
  [EnvNames.staging]: null,
  [EnvNames.prod]: {
    apiKey: 'e011297ae8e44c8d2fc4a742e6672ae3',
    flushIntervalMillis: 5000,
  },
};

export const growthbookClientKeys: Record<EnvNames, string | null> = {
  [EnvNames.local]: 'sdk-ObY9xgDX2WGKR0lb',
  [EnvNames.dev]: 'sdk-ObY9xgDX2WGKR0lb',
  [EnvNames.staging]: null,
  [EnvNames.prod]: 'sdk-9oiALreKeDslB6p',
};

export const disabledAmplitudeConfigurations: AmplitudeConfigurationMap = {
  [EnvNames.local]: null,
  [EnvNames.dev]: null,
  [EnvNames.staging]: null,
  [EnvNames.prod]: null,
};

export const vdrFileAppHosts: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://ir.dev.pinnakl.com',
  [EnvNames.dev]: 'https://ir.dev.pinnakl.com',
  [EnvNames.staging]: 'https://ir.pinnakl.com',
  [EnvNames.prod]: 'https://ir.pinnakl.com',
};

export const platformGrpcApiServerUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://datastream-grpc-dev.pinnakl.com',
  [EnvNames.dev]: 'https://oms-grpc.dev.pinnakl.com',
  [EnvNames.staging]: 'https://datastream-grpc-prod.pinnakl.com',
  [EnvNames.prod]: 'https://datastream-grpc-prod.pinnakl.com',
};

export const platformMarketDataGrpcApiServerUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://appsvc-pinnakl-pulse-dev.azurewebsites.net',
  [EnvNames.dev]: 'https://appsvc-pinnakl-pulse-dev.azurewebsites.net',
  [EnvNames.staging]: 'https://appsvc-pinnakl-pulse-dev.azurewebsites.net',
  [EnvNames.prod]: 'https://appsvc-pinnakl-pulse-dev.azurewebsites.net',
};

export const platformFileServiceUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://localhost:53591/File/',
  [EnvNames.dev]: 'https://external-services-dev.pinnakl.com/File/',
  [EnvNames.staging]: 'https://external-services-prod.pinnakl.com/File/',
  [EnvNames.prod]: 'https://external-services-prod.pinnakl.com/File/',
};

const platformCrmAppUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://localhost:53591/',
  [EnvNames.dev]: 'https://crmappstage.azurewebsites.net/',
  [EnvNames.staging]: 'https://crmappstage.azurewebsites.net/',
  [EnvNames.prod]: 'https://backendMiscService.pinnakl.com/',
};

export const platformFrontEndErrorServiceUrls = createFrontEndErrorServiceUrls(platformCrmAppUrls);

export const platformDatastream1Urls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://localhost:44393/api/',
  [EnvNames.dev]: 'https://appsvc-sse-dev.azurewebsites.net/api/',
  [EnvNames.staging]: 'https://sse.pinnakl.com/api/',
  [EnvNames.prod]: 'https://sse.pinnakl.com/api/',
};

export const platformCoreApiServerUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://localhost:51490',
  [EnvNames.dev]: 'https://apicore-dev.pinnakl.com',
  [EnvNames.staging]: 'https://apicore-prod-002.pinnakl.com',
  [EnvNames.prod]: 'https://apicore-prod-001.pinnakl.com',
};

export const platformAuthUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://localhost:5149',
  [EnvNames.dev]: 'https://identity.dev.pinnakl.com',
  [EnvNames.staging]: 'https://identity.pinnakl.com',
  [EnvNames.prod]: 'https://identity.pinnakl.com',
};

export const platformTradingServiceUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://localhost:44323/api/',
  [EnvNames.dev]: 'https://appsvc-legacy-trading-dev.azurewebsites.net/api/',
  [EnvNames.staging]: 'https://services.pinnakl.com/api/',
  [EnvNames.prod]: 'https://services.pinnakl.com/api/',
};

export const crmGrpcApiServerUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://datastream-grpc-dev.pinnakl.com',
  [EnvNames.dev]: 'https://datastream-grpc-dev.pinnakl.com',
  [EnvNames.staging]: 'https://datastream-grpc-prod.pinnakl.com',
  [EnvNames.prod]: 'https://datastream-grpc-prod.pinnakl.com',
};

export const crmFileServiceUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://localhost:53591/File/',
  [EnvNames.dev]: 'https://external-services-dev.pinnakl.com/File/',
  [EnvNames.staging]: 'https://external-services-dev.pinnakl.com/File/',
  [EnvNames.prod]: 'https://documents.pinnakl.com/File/',
};

const crmAppUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://localhost:53591/',
  [EnvNames.dev]: 'https://external-services-dev.pinnakl.com',
  [EnvNames.staging]: 'https://external-services-dev.pinnakl.com',
  [EnvNames.prod]: 'https://documents.pinnakl.com/',
};

export const crmFrontEndErrorServiceUrls = createFrontEndErrorServiceUrls(crmAppUrls);

export const crmCoreApiServerUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://localhost:51490',
  [EnvNames.dev]: 'https://apicore-dev.pinnakl.com',
  [EnvNames.staging]: 'https://apicore-prod-002.pinnakl.com',
  [EnvNames.prod]: 'https://apicore-prod-002.pinnakl.com',
};

export const crmDatastream1Urls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://localhost:44393/api/',
  [EnvNames.dev]: 'https://appsvc-sse-dev.azurewebsites.net/api/',
  [EnvNames.staging]: 'https://sse.pinnakl.com/api/',
  [EnvNames.prod]: 'https://sse.pinnakl.com/api/',
};

export const crmAuthUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://localhost:5149',
  [EnvNames.dev]: 'https://identity.dev.pinnakl.com',
  [EnvNames.staging]: 'https://identity.pinnakl.com',
  [EnvNames.prod]: 'https://identity.pinnakl.com',
};

export const emailsCollectorUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://appsvc-emailscollector-dev-e7h7gferhuaag9dr.centralus-01.azurewebsites.net',
  [EnvNames.dev]: 'https://appsvc-emailscollector-dev-e7h7gferhuaag9dr.centralus-01.azurewebsites.net',
  [EnvNames.staging]: 'https://appsvc-emailscollector-prod.azurewebsites.net',
  [EnvNames.prod]: 'https://appsvc-emailscollector-prod.azurewebsites.net',
};

export const pinnaklApiUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://app.dev.pinnakl.com',
  [EnvNames.dev]: 'https://app.dev.pinnakl.com',
  [EnvNames.staging]: 'https://app.stage.pinnakl.com',
  [EnvNames.prod]: 'https://app.pinnakl.com',
};

export const portalFileServiceUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://localhost:53591/File/',
  [EnvNames.dev]: 'https://external-services-dev.pinnakl.com/File/',
  [EnvNames.staging]: 'https://documents.pinnakl.com/File/',
  [EnvNames.prod]: 'https://documents.pinnakl.com/File/',
};

export const portalHttpServerUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://localhost:51490',
  [EnvNames.dev]: 'https://apicore-dev.pinnakl.com',
  [EnvNames.staging]: 'https://apicore-prod-002.pinnakl.com',
  [EnvNames.prod]: 'https://apicore-prod-002.pinnakl.com',
};

export const investorPortalAuthUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://localhost:5149',
  [EnvNames.dev]: 'https://identity.dev.pinnakl.com',
  [EnvNames.staging]: 'https://identity.pinnakl.com',
  [EnvNames.prod]: 'https://identity.pinnakl.com',
};

export const dedicatedInvestorPortalAuthUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://localhost:5149',
  [EnvNames.dev]: 'https://auth.kinetic.dev.pinnakl.com',
  [EnvNames.staging]: 'https://auth.investors.kineticpartners.com',
  [EnvNames.prod]: 'https://auth.investors.kineticpartners.com',
};

export const authenticatorFileServiceUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://localhost:53591/File/',
  [EnvNames.dev]: 'https://appsvc-externalservices-dev.azurewebsites.net/File/',
  [EnvNames.staging]: 'https://appsvc-externalservices-dev.azurewebsites.net/File/',
  [EnvNames.prod]: 'https://external-services-prod.pinnakl.com/File/',
};

const authenticatorCrmAppUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://localhost:53591/',
  [EnvNames.dev]: 'https://appsvc-externalservices-dev.azurewebsites.net',
  [EnvNames.staging]: 'https://appsvc-externalservices-dev.azurewebsites.net',
  [EnvNames.prod]: 'https://external-services-prod.pinnakl.com/',
};

export const authenticatorFrontEndErrorServiceUrls = createFrontEndErrorServiceUrls(authenticatorCrmAppUrls);

export const authenticatorCoreApiServerUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://localhost:5149',
  [EnvNames.dev]: 'https://apicore-dev.pinnakl.com',
  [EnvNames.staging]: 'https://apicore-prod-002.pinnakl.com',
  [EnvNames.prod]: 'https://apicore-prod-001.pinnakl.com',
};

export const authenticatorDatastream1Urls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://localhost:44393/api/',
  [EnvNames.dev]: 'https://appsvc-sse-dev.azurewebsites.net/api/',
  [EnvNames.staging]: 'https://appsvc-sse-stage.azurewebsites.net/api/',
  [EnvNames.prod]: 'https://sse.pinnakl.com/api/',
};

export const authenticatorAuthUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://localhost:5149',
  [EnvNames.dev]: 'https://identity.dev.pinnakl.com',
  [EnvNames.staging]: 'https://identity.pinnakl.com',
  [EnvNames.prod]: 'https://identity.pinnakl.com',
};

export const crmDocumentsFileServiceUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://external-services-dev.pinnakl.com',
  [EnvNames.dev]: 'https://external-services-dev.pinnakl.com',
  [EnvNames.staging]: 'https://documents.pinnakl.com',
  [EnvNames.prod]: 'https://documents.pinnakl.com',
};

export const crmDocumentsAuthUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://localhost:5149',
  [EnvNames.dev]: 'https://identity.dev.pinnakl.com',
  [EnvNames.staging]: 'https://identity.pinnakl.com',
  [EnvNames.prod]: 'https://identity.pinnakl.com',
};

export const crmDocumentsCoreApiServerUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'https://localhost:51490',
  [EnvNames.dev]: 'https://apicore-dev.pinnakl.com',
  [EnvNames.staging]: 'https://apicore-prod-002.pinnakl.com',
  [EnvNames.prod]: 'https://apicore-prod-002.pinnakl.com',
};

export const outlookAddinFileServiceUrls: EnvironmentUrlMap = {
  [EnvNames.local]: 'http://localhost:60524/File',
  [EnvNames.dev]: 'https://external-services-dev.pinnakl.com/File',
  [EnvNames.staging]: 'https://appsvc-pinnakl-crm-services-dev.azurewebsites.net/File',
  [EnvNames.prod]: 'https://external-services-prod.pinnakl.com/File',
};

export { outlookAddinAuthUrls, outlookAddinCoreApiServerUrls } from './outlook-addin.urls';

function createFrontEndErrorServiceUrls(appUrls: EnvironmentUrlMap): EnvironmentUrlMap {
  const frontEndErrorPath = 'FrontEndError/Post';

  return {
    [EnvNames.local]: `${appUrls[EnvNames.local]}${frontEndErrorPath}`,
    [EnvNames.dev]: `${appUrls[EnvNames.dev]}${frontEndErrorPath}`,
    [EnvNames.staging]: `${appUrls[EnvNames.staging]}${frontEndErrorPath}`,
    [EnvNames.prod]: `${appUrls[EnvNames.prod]}${frontEndErrorPath}`,
  };
}
